import { render, staticRenderFns } from "./HelpGroupRecipientModal.vue?vue&type=template&id=a1f13f1c&"
import script from "./HelpGroupRecipientModal.vue?vue&type=script&lang=js&"
export * from "./HelpGroupRecipientModal.vue?vue&type=script&lang=js&"
import style0 from "./HelpGroupRecipientModal.vue?vue&type=style&index=0&id=a1f13f1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports